// meta-frentista-ia-a6 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{n} de %{total} frentistas já bateriam": "%{n} de %{total} playeros ya lo alcanzarían",
    "A IA está montando a sugestão…": "La IA está armando la sugerencia…",
    "Ainda não há histórico suficiente para sugerir uma meta nestes postos e dias.": "Aún no hay historial suficiente para sugerir un objetivo en estas estaciones y días.",
    "Aplicar esta meta": "Aplicar este objetivo",
    "Atualizar sugestão": "Actualizar sugerencia",
    "Com este histórico só há um valor possível.": "Con este historial solo hay un valor posible.",
    "Conservadora": "Conservadora",
    "Desafiadora": "Desafiante",
    "Dias batidos no histórico: %{pct}%": "Días alcanzados en el historial: %{pct}%",
    "Equilibrada": "Equilibrada",
    "Equipe com ritmos bem diferentes: recomendamos começar pelo nível Conservadora.": "Equipo con ritmos muy distintos: recomendamos empezar por el nivel Conservadora.",
    "Equipe pequena: recomendamos começar pelo nível Conservadora.": "Equipo pequeño: recomendamos empezar por el nivel Conservadora.",
    "Fechar": "Cerrar",
    "Módulo desativado": "Módulo desactivado",
    "Não foi possível sugerir agora. Tente novamente em instantes.": "No fue posible sugerir ahora. Intente nuevamente en unos instantes.",
    "O módulo Meta de Frentista está desativado para a sua rede.": "El módulo Objetivo del Playero está desactivado para su red.",
    "Recomendada": "Recomendada",
    "Sugerir com IA": "Sugerir con IA",
};

export default catalogo;
